export default __webpack_public_path__ + "static/media/army_52.6ec23f5b.jpg";